var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C7.10457 0 8 0.895431 8 2V6C8 7.10457 7.10457 8 6 8H2C0.895431 8 0 7.10457 0 6V2C0 0.89543 0.895431 0 2 0H6Z",
    fill: "#FCFCFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C17.1046 0 18 0.895431 18 2V6C18 7.10457 17.1046 8 16 8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0H16Z",
    fill: "#FCFCFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C12 10.4477 11.5523 10 11 10C10.4477 10 10 10.4477 10 11V17C10 17.5523 10.4477 18 11 18C11.5523 18 12 17.5523 12 17V11Z",
    fill: "#FCFCFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11V12.5C13 13.0523 13.4477 13.5 14 13.5C14.5523 13.5 15 13.0523 15 12.5V11Z",
    fill: "#FCFCFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5C14.5523 14.5 15 14.9477 15 15.5V17C15 17.5523 14.5523 18 14 18C13.4477 18 13 17.5523 13 17V15.5C13 14.9477 13.4477 14.5 14 14.5Z",
    fill: "#FCFCFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11V17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17V11Z",
    fill: "#FCFCFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10C7.10457 10 8 10.8954 8 12V16C8 17.1046 7.10457 18 6 18H2C0.895431 18 0 17.1046 0 16V12C0 10.8954 0.895431 10 2 10H6Z",
    fill: "#FCFCFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/QR-icon.ce8b28657b647c0d9e46107644f9e98e.svg";
export { ForwardRef as ReactComponent };